<div class="wrapper confinement">
  <div class="back-link-container content-box-only-width">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'DASHBOARD.MODIFY_DATA' | translate }}
    </a>
  </div>
  <mat-card class="confinement">
    <mat-card-title>{{ 'ACCOUNT.CHANGE_BIRTHDATE.TITLE' | translate }}</mat-card-title>
    <mat-card-content>
      <div>
        <p class="break-word-on-overflow">
          {{ 'ACCOUNT.CHANGE_BIRTHDATE.CURRENT_BIRTHDATE' | translate }}:&nbsp;{{
            currentBirthdate$ | async | replaceEmptyWithString : '-'
          }}
        </p>
      </div>
      <ng-container>
        <div class="form-container">
          <form (keydown.enter)="$event.preventDefault(); onSubmit()">
            <div class="form-field">
              <mat-form-field (mousedown)="picker.open()" appearance="fill" floatLabel="always">
                <mat-label>{{ 'ACCOUNT.CHANGE_BIRTHDATE.NEW_BIRTHDATE' | translate }}</mat-label>
                <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)" [disabled]="true" />
              </mat-form-field>
              <mat-datepicker-toggle [for]="picker" [disabled]="false"></mat-datepicker-toggle>
              <mat-datepicker color="primary" #picker [disabled]="false"></mat-datepicker>
            </div>
          </form>
          <div class="submit-button-wrapper">
            <button
              type="button"
              mat-flat-button
              color="primary"
              (click)="onSubmit()"
              [class.button-spinner]="this.pending"
              [disabled]="this.pending || !this.formIsDirty"
            >
              {{ 'GENERAL.SAVE_CHANGE' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
